import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ArticleCard from "@/components/base/ArticleCard";
import { categories, getCategoryBySlug } from "@/mocks/categories";
import { getArticlesByCategory } from "@/mocks/articles";

const getCategoryLabel = (slug: string): string => {
  const map: Record<string, string> = {
    yingshi: "影视资源",
    ruanjian: "软件资源",
    wendang: "文档资源",
    yinyue: "音乐资源",
    youxi: "游戏资源",
    qita: "其他资源",
  };
  return map[slug] || slug;
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || "yingshi");

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [slug]);

  const category = getCategoryBySlug(activeSlug);
  const categoryArticles = getArticlesByCategory(activeSlug);

  return (
    <>
      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100">
          <div className="w-full px-4 md:px-6 py-4">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: category?.name || "分类" },
              ]}
            />
          </div>

          <div className="w-full px-4 md:px-6 py-10 md:py-14">
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-4">
              {category?.name || "资源分类"}
              <span className="text-primary-500">磁力搜索</span>
            </h1>
            <p className="text-foreground-500 text-base max-w-2xl leading-relaxed">
              {category?.description ||
                "按分类浏览磁力搜索教程和资源获取指南"}
            </p>
          </div>
        </div>

        <div className="w-full px-4 md:px-6 py-6 bg-background-50 border-b border-background-200/60 overflow-x-auto">
          <div className="flex items-center gap-2 min-w-max">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  activeSlug === cat.slug
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-primary-100/70 hover:text-primary-600"
                }`}
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6">
            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-background-100 flex items-center justify-center">
                  <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">
                  该分类暂无文章，请查看其他分类
                </p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}